module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="progress-view">\n    <div class="progress-content">\n      <div class="progress-text"></div>\n      <div class="pong-spinner"><i /></div>\n    </div>\n    <div class="progress-message">\n      <div class="progress-action"></div>\n    </div>\n  </div>\n';
}
return __p;
};
